module.exports = __webpack_public_path__ + "img/332x454px.499b43c3.png";